import axiosInstance from "../../../../api/axiosInstance";
import { endpoints } from "../../../../services/endpoints";
import {
  updateSupportStatusRequest,
  updateSupportStatusSuccess,
  updateSupportStatusError,
} from "../../../slices/teams/members/UpdateSupportStatusSlice";

export const UpdateSupportStatus = (id) => async (dispatch) => {
  try {
    dispatch(updateSupportStatusRequest());

    const response = await axiosInstance.put(`${endpoints.updateSupportStatus}/${id}`, {
      headers: { "Content-Type": "application/json" },
    });

    dispatch(updateSupportStatusSuccess(response.data));
    return response.data;
  } catch (error) {
    const _error = {
      data: error?.response?.data?.message || error?.message,
      status: error?.response?.status,
    };
    dispatch(updateSupportStatusError(_error));
    throw _error;
  }
};
